<template>
  <div id="panneauxNumerique" class="topVert"
       v-if="detailPanneauxNumeriqueFilter.length">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold has-text-link bottomBleu">
        Proposition face(s) numérique(s)
      </h2>
    </div>
    <div class="goToTop" >
      <app-carte-panneaux-numerique :markers="detailPanneauxNumeriqueFilter"
      :markerVenteNumerique="markerVenteNumerique"/>
    </div>
    <h3 class="has-text-weight-bold has-text-link bottomVert topRouge">
      Liste face(s) numérique(s)
    </h3>
    <app-listes-faces-numerique :detailPanneauxNumerique="detailPanneauxNumeriqueFilter"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import cartePanneauxNumerique from './cartePanneauxNumerique';
import listesFacesNumerique from './listesFacesNumerique';

export default {
  name: 'index',
  props: ['detailPanneauxNumerique', 'adresseVenteNumerique'],
  components: {
    appCartePanneauxNumerique: cartePanneauxNumerique,
    appListesFacesNumerique: listesFacesNumerique,
  },
  data() {
    return {
      markerVenteNumerique: {},
    };
  },
  computed: {
    ...mapGetters(['getMaSelection']),
    detailPanneauxNumeriqueFilter() {
      const data = this.detailPanneauxNumerique.filter(d =>
        !d.extensionOpportunite.reseauPersoGuid);
      if (this.getMaSelection) {
        return data.filter(el => el.select);
      }
      return data;
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseVenteNumerique.lat !== undefined) {
        this.markerVenteNumerique = {
          ...this.adresseVenteNumerique,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxNumeriques/index.vue